import styled from "@emotion/styled";

import { FormSubmitButton } from "metabase/forms";

export const StyledInvalidateNowButton = styled(FormSubmitButton)`
  align-self: flex-start;
  padding: 0.75rem;
  min-width: 40px;
  height: 40px;
`;
